(() => {
  const reveal = () => {
    const els = document.querySelectorAll('.sova [data-sova-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach((el) => el.classList.add('is-in')); return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  };

  const initBuy = (root) => {
    if (root.dataset.sovaReady) return; root.dataset.sovaReady = '1';
    const dataEl = root.querySelector('script[data-sova-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = root.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-sova-price]');
    const labelEl = root.querySelector('[data-sova-color-label]');
    const addBtn = root.querySelector('[data-sova-add]');
    const mainImg = root.querySelector('[data-sova-main]');
    const thumbs = root.querySelectorAll('[data-sova-thumb]');

    const setMain = (src, srcset, alt) => {
      if (!mainImg || !src) return;
      mainImg.src = src; if (srcset) mainImg.srcset = srcset; if (alt) mainImg.alt = alt;
      thumbs.forEach((t) => t.setAttribute('aria-current', t.dataset.src === src ? 'true' : 'false'));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => setMain(t.dataset.src, t.dataset.srcset, t.dataset.alt)));

    root.querySelectorAll('input[name="sova-color"]').forEach((input) => {
      input.addEventListener('change', () => {
        const v = variants.find((x) => String(x.id) === input.value);
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price;
        if (labelEl) labelEl.textContent = v.title;
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addBtn.dataset.addLabel : addBtn.dataset.soldLabel; }
        if (v.image) setMain(v.image, v.srcset, v.alt);
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      });
    });

    const qty = root.querySelector('.sova-qty input');
    root.querySelectorAll('[data-sova-qty]').forEach((b) => b.addEventListener('click', () => {
      const n = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.sovaQty)); qty.value = n;
    }));
  };

  const boot = () => { reveal(); document.querySelectorAll('[data-sova-buy]').forEach(initBuy); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
